import React from 'react';
import PropTypes from 'prop-types';
import { withTheme } from 'styled-components';

const Warning = ({ size, color, theme, iconTitle }) => {
  const iconColor = color || (theme && theme.iconColor);
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 36 36"
      color={iconColor}
      fill={iconColor}
    >
      <title>{iconTitle}</title>
      <g
        fill="none"
        fillRule="evenodd"
        strokeLinecap="round"
        strokeLinejoin="round"
        stroke="#FACB46"
        strokeWidth={3}
      >
        <circle cx={18} cy={18} r={18} />
        <path d="M18 10.8V18M18 25.2h.018" />
      </g>
    </svg>
  );
};

Warning.propTypes = {
  color: PropTypes.string,
  iconTitle: PropTypes.string,
  size: PropTypes.number,
  theme: PropTypes.object,
};

Warning.defaultProps = {
  color: null,
  iconTitle: null,
  size: 26,
  theme: null,
};

export default withTheme(Warning);
